import React, { Component } from 'react';
import MyNavbar from './components/navbar';
import Resume from './components/resume';
import Footer from './components/footer';
import './default.css';

class App extends Component {
  render() {
    return (
      <div className="App" id="top" data-spy="scroll" data-target="#navbar" data-offset="340">
        <MyNavbar />
        <Resume />
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js